<!--=====================================
=            ECHARTSPOLARBAR            =
======================================-->
<template>
  <div id="echart4" style="height:400px">

  </div>

</template>
<script>
  export default {
   
    mounted() {

      var chartDom = document.getElementById('echart4');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        angleAxis: {},
        radiusAxis: {
          type: 'category',
          data: ['BTC', 'BNB', 'USDT', 'BRL'],
          z: 5
        },
        polar: {},
        series: [{
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            name: 'A',
            stack: 'a',
            color: '#008744',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              borderRadius: 8,
              width: 2,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            }
          },
          {
            type: 'bar',
            data: [2, 4, 6, 8],
            coordinateSystem: 'polar',
            color: '  #d62d20',
            name: 'B',
            stack: 'a',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              borderRadius: 8,
              width: 2,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            }
          },
          {
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            color: '#014b55',
            name: 'C',
            stack: 'a',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              borderRadius: 8,
              width: 2,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            }
          }
        ],
        legend: {
          show: false,
          data: ['A', 'B', 'C']
        }
      };

      option && myChart.setOption(option);

    }
  }
</script>


<!--====  End of ECHARTSPOLARBAR  ====-->